var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendCommentButtonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47324 18.3874C5.35679 18.3874 5.24033 18.3476 5.12388 18.3078C4.85216 18.1484 4.65807 17.8695 4.65807 17.5508V13.2084C4.65807 13.0092 4.73571 12.81 4.85216 12.6507L10.6748 6.07726C10.9853 5.71871 11.4899 5.71871 11.8393 6.03742C12.1886 6.35614 12.1886 6.87404 11.8781 7.23259L6.2884 13.5271V15.8776L9.54905 13.3678C9.78196 13.2084 10.0925 13.1686 10.3254 13.2482L12.3827 14.0849L14.1295 2.33242L2.48431 8.98549L4.34754 10.101C4.73571 10.34 4.85216 10.8579 4.61926 11.2563C4.38635 11.6547 3.88173 11.7742 3.49356 11.5352L0.388173 9.66275C0.116452 9.5034 0 9.22453 0 8.94566C0 8.62695 0.155269 8.38791 0.42699 8.22856L14.7894 0.101445C15.0611 -0.0579097 15.4105 -0.018071 15.6434 0.141284C15.9151 0.340478 16.0315 0.61935 15.9927 0.93806L13.819 15.3995C13.7801 15.6386 13.6249 15.8776 13.4308 15.9971C13.2367 16.1166 12.965 16.1565 12.7321 16.037L10.1313 14.9613L5.93904 18.1883C5.82259 18.3078 5.66732 18.3874 5.47324 18.3874Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47324 18.3874C5.35679 18.3874 5.24033 18.3476 5.12388 18.3078C4.85216 18.1484 4.65807 17.8695 4.65807 17.5508V13.2084C4.65807 13.0092 4.73571 12.81 4.85216 12.6507L10.6748 6.07726C10.9853 5.71871 11.4899 5.71871 11.8393 6.03742C12.1886 6.35614 12.1886 6.87404 11.8781 7.23259L6.2884 13.5271V15.8776L9.54905 13.3678C9.78196 13.2084 10.0925 13.1686 10.3254 13.2482L12.3827 14.0849L14.1295 2.33242L2.48431 8.98549L4.34754 10.101C4.73571 10.34 4.85216 10.8579 4.61926 11.2563C4.38635 11.6547 3.88173 11.7742 3.49356 11.5352L0.388173 9.66275C0.116452 9.5034 0 9.22453 0 8.94566C0 8.62695 0.155269 8.38791 0.42699 8.22856L14.7894 0.101445C15.0611 -0.0579097 15.4105 -0.018071 15.6434 0.141284C15.9151 0.340478 16.0315 0.61935 15.9927 0.93806L13.819 15.3995C13.7801 15.6386 13.6249 15.8776 13.4308 15.9971C13.2367 16.1166 12.965 16.1565 12.7321 16.037L10.1313 14.9613L5.93904 18.1883C5.82259 18.3078 5.66732 18.3874 5.47324 18.3874Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14,
    width: 114.922,
    height: 114.922,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendCommentButtonWhite);
export default __webpack_public_path__ + "static/media/send-comment-button-white.e62a0d207aeb99dd6736a4be50df3910.svg";
export { ForwardRef as ReactComponent };